import { render, staticRenderFns } from "./colelHours.vue?vue&type=template&id=6cdebd96&scoped=true&"
import script from "./colelHours.vue?vue&type=script&lang=js&"
export * from "./colelHours.vue?vue&type=script&lang=js&"
import style0 from "./colelHours.vue?vue&type=style&index=0&id=6cdebd96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdebd96",
  null
  
)

export default component.exports